import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { Error } from '../error';
import { useMemo } from 'react';
import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { getRadarOptions } from './chart/options';
import { useMissionTraitAnalysis } from './hooks/useMissionTraitAnalysis';
import { useReportingToolsStore } from '../../store/useReportingToolsStore';
import { SuspenseLoading } from '../loading';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend, Title);

export const MissionTraitAnalysis = () => {
  const { radarData, isMobile, error, isPending } = useMissionTraitAnalysis();
  const onOpenDialog = useReportingToolsStore((state) => state.onOpenDialog);
  const page = useReportingToolsStore((state) => state.page);
  const options = useMemo(() => getRadarOptions(isMobile), [isMobile]);

  if (error) {
    return <Error error={error} />;
  }

  return (
    <div className="relative flex h-96 flex-col">
      {isPending && <SuspenseLoading />}
      <div className="flex items-center justify-start gap-4">
        <h2 className="!pb-1 text-sh-22-28 font-medium">{page?.missionTraitAnalysis?.title || ''}</h2>
        <InformationCircleIcon
          className="h-6 w-6 cursor-pointer text-gray-400"
          onClick={() =>
            onOpenDialog({
              title: page?.missionTraitAnalysis?.dialogTitle || '',
              description: page?.missionTraitAnalysis?.dialogDescription || '',
            })
          }
        />
      </div>
      <p className="mb-sh-30 font-cadiz text-sh-xxs text-gray-500">
        {page?.missionTraitAnalysis?.briefDescription ||
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque'}
      </p>
      {radarData.datasets.length > 0 && <Radar data={radarData} options={options} className="!m-0 !p-0" />}
      {radarData.datasets.length === 0 && (
        <div className="flex h-full flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200">
          <p className="text-sh-xs text-gray-500">{page?.missionTraitAnalysis?.noData || ''}</p>
        </div>
      )}
    </div>
  );
};
